<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane" style="padding-left: 4px;">
              <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:10px;">
                  <span class="line color1">
                    <span class="title_general" style="padding-left:10px !important;">
                      {{title}}
                      </span>
                  </span>
              </div>
            </div>
        </div>

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="main_col" v-show="innerform==1">
                <div class="section_header">Beállítás véglegesítése</div>

                <div class="infotext" v-html="infotext1" />

                <div class="btn_cont" style="border-top: solid 2px var(--premblue); margin:20px 0px; text-align:center;padding-top:10px;">
                    <div class="btn grc-noselect" style="margin-right:30px;" @click="Mentes">
                        <i class="fas fa-check btn_icon" style="margin-right:8px;"></i>Beállítások mentése
                    </div>
                    <div class="btn btn_gray grc-noselect" style="min-width: 100px;" @click="Megsem">
                        <i class="fas fa-times btn_icon" style="margin-right:8px;"></i>Mégsem
                    </div>

                </div>

            </div>

            <div class="main_col" v-show="innerform==2">
                <div class="infotext" style="text-align:center;" v-html="infotext2" />
            </div>

            <div class="main_col" v-show="innerform==3">
                <div class="infotext" style="text-align:center;" v-html="infotext3" />
            </div>

        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmCsodakartya_veglegesites',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmCsodakartya",
            gPopupControlName:"",

            innerform:0,

            infotext1:"",
            infotext2:"",
            infotext3:"",
            title:"",
            refnum:"",
      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmCsodakartya", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.title = this.GetTextBookItem("title");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
      },

    async Mentes()
    {
        this.Save(1);
    },

    async Megsem()
    {
        var DialogResult = "";
        var infotext = "Biztosan elveti a beállításokat?";

        var p = grccomp_dialog_yesno_GetDefaults(grcmain_GetTextBookItem("tech", "megerosites"), infotext);             
        p.height = 200;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }

        
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });        

        if (DialogResult != "YES") { return; }

        this.Save(2);

    },

    async Save(pAction)
    {
        this.infotext3 = "";

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sRefnum: this.refnum,
            iAction: pAction
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Save", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.infotext3 = Q.TXDATA[0].strResult;
        this.innerform = 3;
       
        this.$refs.GRCDB.HideLoading();

        
    },



    async Init()
    {
        this.infotext1 = "";
        this.infotext2 = "";

        this.refnum = "";
        if ((GRCAPP_GetParameters.ALIAS == "csodakartya_veglegesites") && (GRCAPP_GetParameters.PC_REFNUM != "") && (GRCAPP_GetParameters.PC_REFNUM != undefined))
        {
            this.refnum = GRCAPP_GetParameters.PC_REFNUM;
            GRCAPP_GetParameters.PC_REFNUM = "";
        }


        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sRefnum: this.refnum
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_CheckResult", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        if (Q.TXDATA[0].intResult == 1)
        {
            this.infotext1 = Q.TXDATA[0].strResult;
            this.innerform = 1;
        }
        else
        {
            this.infotext2 = Q.TXDATA[0].strResult;
            this.innerform = 2;
        }

       
        this.$refs.GRCDB.HideLoading();

        
    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.main_col
{
    width:100%;
    box-sizing: border-box;
    vertical-align: top;
    max-width: 800px;
    margin-left:auto;
    margin-right: auto;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
}

.infotext
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 0px;
}

.section_header
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:20px;
    line-height: 24px;
    font-weight:500;
    text-align: left;
    padding: 8px 0px;
    border-bottom: dotted 2px var(--premblue);
    margin-bottom: 20px;
}


div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 0px;
  text-align: center;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
  background-color: var(--premgreen);
  color:#fff;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: pointer;
}

.btn_gray:hover
{
  background-color: var(--premgreen);
  color:#fff;
}


@media (max-width:900px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }
}


</style>